// @flow
import FormGroupInputField from './FormGroupInputField';
import type { FormGroupInputFieldProps } from './FormGroupInputField';

export default FormGroupInputField;
export type { FormGroupInputFieldProps };
